// import React, { useState } from 'react';
import React from 'react';
import styles from './Footer.module.css';
import logoImage from '../../assets/LogoWhite.png';
import discordIcon from './assets/discord.png';
import telegramIcon from './assets/telegram.png';
import twitterIcon from './assets/twitter.png'; 
import mediumIcon from './assets/medium.png';

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerTop}>
          <div className={styles.footerBrand}>
            <div className={styles.logoContainer}>
              <img src={logoImage} alt="RAYVA" className={styles.logo} />
            </div>
            <p className={styles.tagline}>Your Sight, Driving the Decentralized Economy.</p>
            
            {/* Social Links moved here */}
            <div className={styles.socialLinksContainer}>
              <h3 className={styles.socialTitle}>Follow Us</h3>
              <div className={styles.socialLinks}>
                <a href="https://x.com/rayvo_xyz" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
                  <img src={twitterIcon} alt="Twitter" width="32" height="32" />
                </a>
                <a href="https://discord.gg/wqEkvG7E" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
                  <img src={discordIcon} alt="Discord" width="32" height="32" />
                </a>
                <a href="https://t.me/DeGlassOfficial" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
                  <img src={telegramIcon} alt="Telegram" width="32" height="32" />
                </a>
                <a href="https://medium.com/@jackson_65067" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
                  <img src={mediumIcon} alt="Medium" width="32" height="32" />
                </a>
              </div>
            </div>
          </div>
          
          <div className={styles.footerLinks}>
            <div className={styles.linksColumn}>
              <span className={styles.columnTitle}>Products</span>
              <ul className={styles.linksList}>
                <li><a href="/vision-one">Rayvo One</a></li>
                <li><a href="/nft-lens">NFT Lens</a></li>
                <li><a href="/ecosystem">Ecosystem</a></li>
                <li><a href="/roadmap">Roadmap</a></li>
              </ul>
            </div>
            
            <div className={styles.linksColumn}>
              <span className={styles.columnTitle}>Resources</span>
              <ul className={styles.linksList}>
                <li><a href="https://rayvo.gitbook.io/rayvo" target="_blank" rel="noopener noreferrer">Whitepaper</a></li>
                <li><a href="/docs">Documentation</a></li>
                <li><a href="/faq">FAQ</a></li>
                <li><a href="/blog">Blog</a></li>
              </ul>
            </div>
            
            <div className={styles.linksColumn}>
              <span className={styles.columnTitle}>Community</span>
              <ul className={styles.linksList}>
                <li><a href="https://x.com/rayvo_xyz" target="_blank" rel="noopener noreferrer">Twitter</a></li>
                <li><a href="https://discord.gg/wqEkvG7E" target="_blank" rel="noopener noreferrer">Discord</a></li>
                <li><a href="https://t.me/DeGlassOfficial" target="_blank" rel="noopener noreferrer">Telegram</a></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className={styles.footerDivider}></div>
        
        <div className={styles.footerBottom}>
          <div className={styles.copyright}>
            © {new Date().getFullYear()} RAYVO. All rights reserved
          </div>
          
          <div className={styles.legalLinks}>
            <a href="/terms">Terms of Use</a>
            <a href="/policy">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;